import React from "react";
// material ui core
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

// Custom components
import { Dashboard as DashboardLayout } from "../../../../layouts/";
// Styles
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import subscriptionCommon from "./common";
import CountersInfo from "../SubscriptionInfo/countersInfo";

class AccessDenyPage extends React.Component {
  render() {
    const { classes, ownerInfo } = this.props;
    return (
      <DashboardLayout title="Profile">
        <Grid container spacing={5}>
          <Grid item lg={12} xs={12} md={12}>
            <Paper className={classes.root} elevation={1}>
              <br />
              <Typography variant="h3" component="h3">
                Access Info
              </Typography>
              <Typography style={{ paddingTop: "10px" }} />
              <br />
              <br />
              <br />
              <br />
              <Typography variant="h5" component="h5">
                Application owner info
              </Typography>
              <Typography style={{ paddingTop: "10px" }}>
                Please contact application owner {ownerInfo.given_name} {ownerInfo.family_name} ({" "}
                <a href={"mailto:" + ownerInfo.email}>{ownerInfo.email}</a> ) ...
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </DashboardLayout>
    );
  }
}

AccessDenyPage.propTypes = {};

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({}, dispatch),
    dispatch
  };
}

AccessDenyPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(AccessDenyPage);

export default withStyles(subscriptionCommon.styles)(AccessDenyPage);
